module.exports = __webpack_public_path__ + "media/entities/2312-d00bd9ac.png";